import React from "react";

import SupplyPickupTabGroup from "./SupplyPickupTabGroup/SupplyPickupTabGroup";

import "./SupplyPickup.css";

export default function SupplyPickup(props) {
  return <SupplyPickupTabGroup history={props.history} />;
}
